import { render } from "./ModalNewContract.vue?vue&type=template&id=0d060b13&scoped=true&ts=true"
import script from "./ModalNewContract.vue?vue&type=script&lang=ts"
export * from "./ModalNewContract.vue?vue&type=script&lang=ts"

import "./ModalNewContract.vue?vue&type=style&index=0&id=0d060b13&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d060b13"]])

export default __exports__